export default __webpack_public_path__ + "static/media/Ten.37cc4d8f.jpeg";